export const wordsData = {
    people: [
        { id: 'mama', label: 'Mama', emoji: '👩', color: '#FF6B6B' },
        { id: 'dada', label: 'Dada', emoji: '👨', color: '#4ECDC4' },
        { id: 'baby', label: 'Baby', emoji: '👶', color: '#FFE66D' },
        { id: 'brother', label: 'Brother', emoji: '👦', color: '#1A535C' },
        { id: 'sister', label: 'Sister', emoji: '👧', color: '#FF9F1C' },
    ],
    animals: [
        { id: 'cat', label: 'Cat', emoji: '🐱', color: '#FF6B6B' },
        { id: 'dog', label: 'Dog', emoji: '🐶', color: '#4ECDC4' },
        { id: 'lion', label: 'Lion', emoji: '🦁', color: '#FFE66D' },
        { id: 'elephant', label: 'Elephant', emoji: '🐘', color: '#1A535C' },
        { id: 'tiger', label: 'Tiger', emoji: '🐯', color: '#FF9F1C' },
        { id: 'monkey', label: 'Monkey', emoji: '🐵', color: '#2EC4B6' },
        { id: 'bird', label: 'Bird', emoji: '🐦', color: '#9B5DE5' },
        { id: 'fish', label: 'Fish', emoji: '🐟', color: '#F15BB5' },
        { id: 'cow', label: 'Cow', emoji: '🐮', color: '#FEE440' },
        { id: 'horse', label: 'Horse', emoji: '🐴', color: '#00BBF9' },
        { id: 'duck', label: 'Duck', emoji: '🦆', color: '#00F5D4' },
        { id: 'bunny', label: 'Bunny', emoji: '🐰', color: '#FF9F1C' },
        { id: 'ant', label: 'Ant', emoji: '🐜', color: '#E86565' },
        { id: 'alligator', label: 'Alligator', emoji: '🐊', color: '#2EC4B6' },
        { id: 'snake', label: 'Snake', emoji: '🐍', color: '#9B5DE5' },
        { id: 'rat', label: 'Rat', emoji: '🐀', color: '#FF6B6B' },
        { id: 'spider', label: 'Spider', emoji: '🕷️', color: '#62BA47' },
    ],
    vehicles: [
        { id: 'car', label: 'Car', emoji: '🚗', color: '#FF6B6B' },
        { id: 'bus', label: 'Bus', emoji: '🚌', color: '#4ECDC4' },
        { id: 'truck', label: 'Truck', emoji: '🚛', color: '#FFE66D' },
        { id: 'bicycle', label: 'Bicycle', emoji: '🚲', color: '#1A535C' },
        { id: 'train', label: 'Train', emoji: '🚂', color: '#FF9F1C' },
        { id: 'airplane', label: 'Airplane', emoji: '✈️', color: '#2EC4B6' },
        { id: 'rocket', label: 'Rocket', emoji: '🚀', color: '#9B5DE5' },
        { id: 'firetruck', label: 'Fire Truck', emoji: '🚒', color: '#FF6B6B' },
        { id: 'copcar', label: 'Police Car', emoji: '🚓', color: '#4ECDC4' },
        { id: 'ambulance', label: 'Ambulance', emoji: '🚑', color: '#FFE66D' },
        { id: 'trashtruck', label: 'Trash Truck', emoji: '🚚', color: '#1A535C' },
    ],
    foods: [
        { id: 'apple', label: 'Apple', emoji: '🍎', color: '#FF6B6B' },
        { id: 'banana', label: 'Banana', emoji: '🍌', color: '#FFE66D' },
        { id: 'pizza', label: 'Pizza', emoji: '🍕', color: '#FF9F1C' },
        { id: 'burger', label: 'Burger', emoji: '🍔', color: '#4ECDC4' },
        { id: 'icecream', label: 'Ice Cream', emoji: '🍦', color: '#F15BB5' },
        { id: 'cookie', label: 'Cookie', emoji: '🍪', color: '#1A535C' },
    ],
    bodyParts: [
        { id: 'head', label: 'Head', emoji: '👦', color: '#FF6B6B' },
        { id: 'eyes', label: 'Eyes', emoji: '👀', color: '#4ECDC4' },
        { id: 'nose', label: 'Nose', emoji: '👃', color: '#FFE66D' },
        { id: 'mouth', label: 'Mouth', emoji: '👄', color: '#1A535C' },
        { id: 'hands', label: 'Hands', emoji: '👐', color: '#FF9F1C' },
        { id: 'feet', label: 'Feet', emoji: '🦶', color: '#2EC4B6' },
    ],
    feelings: [
        { id: 'happy', label: 'Happy', emoji: '😊', color: '#FF6B6B' },
        { id: 'sad', label: 'Sad', emoji: '😢', color: '#4ECDC4' },
        { id: 'angry', label: 'Angry', emoji: '😠', color: '#FFE66D' },
        { id: 'scared', label: 'Scared', emoji: '😱', color: '#1A535C' },
        { id: 'silly', label: 'Silly', emoji: '🤪', color: '#FF9F1C' },
        { id: 'tired', label: 'Tired', emoji: '😴', color: '#2EC4B6' },
    ],
    opposites: [
        { id: 'up_down', label: 'Up / Down', emoji: '⬆️/⬇️', color: '#FF6B6B' },
        { id: 'big_small', label: 'Big / Small', emoji: '🐘/🐁', color: '#4ECDC4' },
        { id: 'fast_slow', label: 'Fast / Slow', emoji: '🐆/🐢', color: '#FFE66D' },
        { id: 'in_out', label: 'In / Out', emoji: '📥/📤', color: '#1A535C' },
        { id: 'on_off', label: 'On / Off', emoji: '🟢/🔴', color: '#FF9F1C' },
        { id: 'hot_cold', label: 'Hot / Cold', emoji: '🔥/❄️', color: '#2EC4B6' },
        { id: 'day_night', label: 'Day / Night', emoji: '☀️/🌙', color: '#9B5DE5' },
    ],
    weather: [
        { id: 'sun', label: 'Sun', emoji: '☀️', color: '#FF6B6B' },
        { id: 'rain', label: 'Rain', emoji: '🌧️', color: '#4ECDC4' },
        { id: 'snow', label: 'Snow', emoji: '❄️', color: '#FFE66D' },
        { id: 'cloud', label: 'Cloud', emoji: '☁️', color: '#1A535C' },
        { id: 'wind', label: 'Wind', emoji: '💨', color: '#FF9F1C' },
    ],
    nature: [
        { id: 'tree', label: 'Tree', emoji: '🌳', color: '#2EC4B6' },
        { id: 'flower', label: 'Flower', emoji: '🌸', color: '#9B5DE5' },
        { id: 'grass', label: 'Grass', emoji: '🌿', color: '#F15BB5' },
        { id: 'leaf', label: 'Leaf', emoji: '🍃', color: '#FEE440' },
        { id: 'sky', label: 'Sky', emoji: '🌤️', color: '#00BBF9' },
        { id: 'star', label: 'Star', emoji: '⭐', color: '#00F5D4' },
        { id: 'moon', label: 'Moon', emoji: '🌙', color: '#FF6B6B' },
    ],
    home: [
        { id: 'bed', label: 'Bed', emoji: '🛏️', color: '#4ECDC4' },
        { id: 'chair', label: 'Chair', emoji: '🪑', color: '#FFE66D' },
        { id: 'table', label: 'Table', emoji: '┬─┬', color: '#1A535C' },
        { id: 'door', label: 'Door', emoji: '🚪', color: '#FF9F1C' },
        { id: 'window', label: 'Window', emoji: '🪟', color: '#2EC4B6' },
        { id: 'spoon', label: 'Spoon', emoji: '🥄', color: '#9B5DE5' },
        { id: 'cup', label: 'Cup', emoji: '☕', color: '#F15BB5' },
    ],
    needs: [
        { id: 'more', label: 'More', emoji: '➕', color: '#FF6B6B' },
        { id: 'up', label: 'Up', emoji: '⬆️', color: '#4ECDC4' },
        { id: 'help', label: 'Help', emoji: '🤝', color: '#FFE66D' },
        { id: 'eat', label: 'Eat', emoji: '🍽️', color: '#1A535C' },
        { id: 'drink', label: 'Drink', emoji: '🥤', color: '#FF9F1C' },
        { id: 'milk', label: 'Milk', emoji: '🥛', color: '#2EC4B6' },
        { id: 'sleep', label: 'Sleep', emoji: '😴', color: '#9B5DE5' },
    ],
    social: [
        { id: 'hi', label: 'Hi', emoji: '👋', color: '#F15BB5' },
        { id: 'bye', label: 'Bye', emoji: '👋', color: '#FEE440' },
        { id: 'please', label: 'Please', emoji: '🙏', color: '#00BBF9' },
        { id: 'thank_you', label: 'Thank You', emoji: '🙇', color: '#00F5D4' },
    ],
    direction: [
        { id: 'go', label: 'Go', emoji: '🟢', color: '#FF9F1C' },
        { id: 'stop', label: 'Stop', emoji: '🛑', color: '#2EC4B6' },
        { id: 'no', label: 'No', emoji: '❌', color: '#9B5DE5' },
        { id: 'yes', label: 'Yes', emoji: '✅', color: '#F15BB5' },
        { id: 'open', label: 'Open', emoji: '👐', color: '#FEE440' },
    ],
    sports: [
        { id: 'bat', label: 'Bat', emoji: '🏏', color: '#00F5D4' },
        { id: 'ball', label: 'Ball', emoji: '⚽', color: '#FF9F1C' },
        { id: 'hat', label: 'Hat', emoji: '🧢', color: '#9B5DE5' },
        { id: 'gloves', label: 'Gloves', emoji: '🧤', color: '#2EC4B6' },
        { id: 'jersey', label: 'Jersey', emoji: '👕', color: '#F15BB5' },
        { id: 'shoe', label: 'Shoe', emoji: '👟', color: '#FEE440' },
        { id: 'goal', label: 'Goal', emoji: '🥅', color: '#00BBF9' },
        { id: 'throw', label: 'Throw', emoji: '☄️', color: '#00F5D4' },
        { id: 'kick', label: 'Kick', emoji: '🦵', color: '#FF9F1C' },
    ],
    produce: [
        { id: 'apple', label: 'Apple', emoji: '🍎', color: '#00F5D4' },
        { id: 'banana', label: 'Banana', emoji: '🍌', color: '#FF9F1C' },
        { id: 'orange', label: 'Orange', emoji: '🍊', color: '#2EC4B6' },
        { id: 'grapes', label: 'Grapes', emoji: '🍇', color: '#9B5DE5' },
        { id: 'watermelon', label: 'Watermelon', emoji: '🍉', color: '#F15BB5' },
        { id: 'strawberry', label: 'Strawberry', emoji: '🍓', color: '#F15BB5' },
        { id: 'blueberry', label: 'Blueberry', emoji: '🫐', color: '#FEE440' },
        { id: 'kiwi', label: 'Kiwi', emoji: '🥝', color: '#00BBF9' },
        { id: 'pineapple', label: 'Pineapple', emoji: '🍍', color: '#00F5D4' },
        { id: 'mango', label: 'Mango', emoji: '🥭', color: '#FF9F1C' },
        { id: 'cherry', label: 'Cherry', emoji: '🍒', color: '#9B5DE5' },
        { id: 'avacado', label: 'Avacado', emoji: '🥑', color: '#F15BB5' },
        { id: 'sweet_potato', label: 'Sweet Potato', emoji: '🍠', color: '#FEE440' },
        { id: 'lemon', label: 'Lemon', emoji: '🍋', color: '#FEE440' },
        { id: 'broccoli', label: 'Broccoli', emoji: '🥦', color: '#00F5D4' },
        { id: 'carrot', label: 'Carrot', emoji: '🥕', color: '#FF9F1C' },
        { id: 'potato', label: 'Potato', emoji: '🥔', color: '#9B5DE5' },
        { id: 'tomato', label: 'Tomato', emoji: '🍅', color: '#F15BB5' },
        { id: 'onion', label: 'Onion', emoji: '🧅', color: '#FEE440' },
        { id: 'cucumber', label: 'Cucumber', emoji: '🥒', color: '#00BBF9' },
        { id: 'pepper', label: 'Pepper', emoji: '🌶️', color: '#00F5D4' },
        { id: 'spinach', label: 'Spinach', emoji: '🍃', color: '#FF9F1C' },
        { id: 'lettuce', label: 'Lettuce', emoji: '🥬', color: '#9B5DE5' },
        { id: 'corn', label: 'Corn', emoji: '🌽', color: '#F15BB5' },
        { id: 'eggplant', label: 'Eggplant', emoji: '🍆', color: '#FEE440' },
        { id: 'bell_pepper', label: 'Bell Pepper', emoji: '🫑', color: '#00F5D4' },
        { id: 'egg', label: 'Egg', emoji: '🥚', color: '#FF9F1C' },
        { id: 'meat', label: 'Meat', emoji: '🥩', color: '#9B5DE5' },
        { id: 'fish', label: 'Fish', emoji: '🐟', color: '#F15BB5' },
    ]
};

export const categories = [
    { id: 'people', label: 'People', emoji: '👪', color: '#FF6B6B' },
    { id: 'animals', label: 'Animals', emoji: '🐾', color: '#FF6B6B' },
    { id: 'vehicles', label: 'Vehicles', emoji: '🚗', color: '#4ECDC4' },
    { id: 'foods', label: 'Foods', emoji: '🍔', color: '#FF9F1C' },
    { id: 'bodyParts', label: 'Body Parts', emoji: '👃', color: '#1A535C' },
    { id: 'feelings', label: 'Feelings', emoji: '😊', color: '#FF9F1C' },
    { id: 'opposites', label: 'Opposites', emoji: '↔️', color: '#2EC4B6' },
    { id: 'weather', label: 'Weather', emoji: '🌤️', color: '#9B5DE5' },
    { id: 'nature', label: 'Nature', emoji: '🌳', color: '#F15BB5' },
    { id: 'home', label: 'Home', emoji: '🏠', color: '#F15BB5' },
    { id: 'needs', label: 'Needs', emoji: '🤲', color: '#00BBF9' },
    { id: 'social', label: 'Social', emoji: '👋', color: '#00F5D4' },
    { id: 'direction', label: 'Direction', emoji: '🛑', color: '#FF9F1C' },
    { id: 'sports', label: 'Sports', emoji: '🏀', color: '#2EC4B6' },
    { id: 'produce', label: 'Produce', emoji: '🍎', color: '#9B5DE5' },
];
